import type { Properties } from 'hast';
import type { Node } from 'mdast';

/**
 * Safely set the `hProperties` property on a node which are the HTML Element
 * properties like `class`, `id`, `style`, etc.
 */
export function setHTMLProperties(node: Node, hProperties: Properties) {
  if (!node.data) node.data = {};
  if (!node.data.hProperties) node.data.hProperties = {};

  Object.assign(node.data.hProperties, hProperties);
}
